import { Grid, Stack, Typography } from "@mui/material";
import { convertToFullName } from "../../../services/utils";
import { concatSelectedFromToTime } from "../../../services/date-and-time.utils";
import RecordingCard from "./RecordingCard";
import RecordingCardSkeleton from "./RecordingCardSkeleton";

export type RecordingCardPrimaryParty = "ambassador" | "client";

interface RecordingListProps {
  fetching: boolean;
  list: any[] | undefined;
  isError: boolean;
  cardPrimaryParty: RecordingCardPrimaryParty;
}

export default function RecordingList({
  fetching,
  list,
  isError,
  cardPrimaryParty,
}: RecordingListProps) {
  if (fetching) {
    return (
      <Stack spacing={2}>
        {[0, 1, 2].map((i) => (
          <RecordingCardSkeleton key={i} />
        ))}
      </Stack>
    );
  }

  if (isError) {
    return (
      <Typography color="error" variant="body2">
        Something went wrong while loading recordings. Please try again.
      </Typography>
    );
  }

  if (!list || list.length === 0) {
    return (
      <Typography color="text.secondary" variant="body2">
        No meeting recordings found.
      </Typography>
    );
  }

  return (
    <Grid container spacing={2}>
      {list.map((rec, idx) => (
        <Grid key={rec?.id ?? idx} item xs={12}>
          <RecordingCard
            data={{
              ...rec,
              title: rec?.[cardPrimaryParty]?.title,
              name: convertToFullName(
                rec?.[cardPrimaryParty]?.firstName,
                rec?.[cardPrimaryParty]?.lastName
              )?.trim(),
              company: rec?.[cardPrimaryParty]?.company,
              selectedTimeSlot: concatSelectedFromToTime(rec?.selectedTimeSlot),
              selectedTimeSlotRaw: rec?.selectedTimeSlot,
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
}
